import { passwordPattern } from 'utils/passwordPattern';
import * as yup from 'yup';

export const userUpdatePasswordSchema = yup.object().shape({
  actualPassword: yup
    .string()
    .required('El campo Contraseña Actual es requerido'),
  newPassword: yup
    .string()
    .required('El campo Nueva Contraseña es requerido')
    .min(8, 'La contraseña debe tener al menos 8 caracteres')
    .max(16, 'La contraseña debe tener como máximo 16 caracteres')
    .matches(
      passwordPattern,
      'La contraseña debe tener al menos una letra mayúscula, una minúscula, un número y un caracter especial'
    ),
  confirmPassword: yup
    .string()
    .required('El campo Confirmar Contraseña es requerido')
    .oneOf([yup.ref('newPassword'), null], 'Las contraseñas deben ser iguales.')
});
